import { render, staticRenderFns } from "./Grants.vue?vue&type=template&id=72a228ba&scoped=true"
import script from "./Grants.vue?vue&type=script&lang=js"
export * from "./Grants.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72a228ba",
  null
  
)

export default component.exports